import React from 'react';
import withExtensionContextConsumer from '../hoc/withExtensionContextConsumer';
import { hexToCssHex } from '../utils';
import defaultLogo from '../../../../assets/images/receipt/squire-logo.svg';

// eslint-disable-next-line react/prop-types
const Logo = ({ extension }) => {
  // Overriding the extension is a fix for backwards compatibility of email routes;
  // There are cases where emails are sent w/out providing a brand/brandId route
  // and in these cases, displayed notifications would get a 404 when requesting a brand.
  // Therefore this is a default fallback, in case the brand route isn't available.

  // A more elaborate fix is possible with cascading requests after pulling data about
  // the reservation, but it would increase page load times before first render
  // and we're nuking it all in WOM-656 anyway.
  const ext = extension || {
    primaryColor: '0xFFFFFF',
    appIconImage: defaultLogo,
  };

  const styles = { backgroundColor: hexToCssHex(ext.primaryColor), borderRadius: '8px' };
  return (
    <img style={styles} width="64px" height="64px" src={ext.appIconImage} alt="Logo" />
  );
};

export default withExtensionContextConsumer(Logo);



// WEBPACK FOOTER //
// ./src/app/notifications/shared/Logo.jsx